import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import UpcomingExamsTab from "./UpcomingExamsTab";
import OngoingExamsTab from "./OngoingExamsTab";
import CompletedExamsTab from "./CompletedExamsTab";

const ExamTabs = ({
  pendingExams,
  ongoingExams,
  completedExams,
  selectedCompany,
  companies,
  onStartExam,
  onViewResult,
  loadingResult,
  examType,
  onExamTypeChange,
}) => {
  const handleTabChange = (value) => {
    onExamTypeChange(value);
  };

  return (
    <Tabs
      value={examType}
      onValueChange={handleTabChange}
      className="space-y-4"
    >
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger value="pending">Upcoming Exams</TabsTrigger>
        <TabsTrigger value="ongoing">In Progress</TabsTrigger>
        <TabsTrigger value="completed">Completed</TabsTrigger>
      </TabsList>

      <TabsContent value="pending">
        <UpcomingExamsTab
          pendingExams={pendingExams}
          selectedCompany={selectedCompany}
          companies={companies}
          onStartExam={onStartExam}
        />
      </TabsContent>

      <TabsContent value="ongoing">
        <OngoingExamsTab
          ongoingExams={ongoingExams}
          selectedCompany={selectedCompany}
          companies={companies}
          onStartExam={onStartExam}
        />
      </TabsContent>

      <TabsContent value="completed">
        <CompletedExamsTab
          completedExams={completedExams}
          selectedCompany={selectedCompany}
          companies={companies}
          onViewResult={onViewResult}
          loadingResult={loadingResult}
        />
      </TabsContent>
    </Tabs>
  );
};

export default ExamTabs;
